import { BIS, OPEN_DATA, getAppRoute } from 'data/dataSourceConstants';
import { dataConfig } from 'data/dataConfig';
import dataTables from 'view/dataTables';

/** Datasets with multiple sources shown as one sidebar item; sources switch via header dropdown. */
export const PRIMARY_SOURCED_MENU_CONFIG = {
	workApplications: {
		menuLabel: 'Work Application (BIS)',
		anchorDataSet: 'jobApplications',
		entries: [
			{ dataSet: 'jobApplications', dataSource: BIS, label: 'BIS' },
			{ dataSet: 'jobApplications', dataSource: OPEN_DATA, label: 'BIS 2' },
		],
		defaultEntry: { dataSet: 'jobApplications', dataSource: BIS },
	},
	workApplicationsDobNow: {
		menuLabel: 'Work Application (DOB Now)',
		anchorDataSet: 'dobJobApplications',
		entries: [
			{
				dataSet: 'dobJobApplications',
				dataSource: OPEN_DATA,
				label: 'DOB Now',
			},
		],
		defaultEntry: { dataSet: 'dobJobApplications', dataSource: OPEN_DATA },
	},
};

export function getEntryKey(dataSet, dataSource) {
	return `${dataSet}::${dataSource}`;
}

export function parseEntryKey(entryKey) {
	const [dataSet, dataSource] = entryKey.split('::');
	return { dataSet, dataSource };
}

export function getPrimarySourcedMenuConfigForDataSet(dataSet) {
	return (
		Object.values(PRIMARY_SOURCED_MENU_CONFIG).find((cfg) =>
			cfg.entries.some((entry) => entry.dataSet === dataSet),
		) || null
	);
}

export function isPrimarySourcedDataSet(dataSet) {
	return !!getPrimarySourcedMenuConfigForDataSet(dataSet);
}

export function hasPrimarySourceDropdown(dataSet) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	return menuConfig && menuConfig.entries.length > 1;
}

export function isPrimarySourcedAnchorDataSet(dataSet) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	return menuConfig?.anchorDataSet === dataSet;
}

export function shouldHideStandaloneDataSetLink(dataSet) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	return menuConfig && menuConfig.anchorDataSet !== dataSet;
}

export function getPrimarySourceLabel(dataSet, dataSource) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	const entry = menuConfig?.entries.find(
		(e) => e.dataSet === dataSet && e.dataSource === dataSource,
	);
	return entry?.label ?? null;
}

export function getPrimarySourcedMenuLabel(menuConfig) {
	if (menuConfig?.menuLabel) {
		return menuConfig.menuLabel;
	}
	const config = getAnchorConfig(menuConfig);
	return config?.title || config?.navTitle || config?.singularTitle;
}

export function getAnchorConfig(menuConfig) {
	return dataTables[menuConfig.anchorDataSet];
}

/** Sidebar badge uses the default source only, not a sum across sources. */
export function getPrimarySourcedIssueCount(menuConfig, propertyData) {
	if (!menuConfig) {
		return 0;
	}
	const { dataSet, dataSource } = menuConfig.defaultEntry;
	const countField = dataConfig[dataSet]?.openIssueCountFields?.[dataSource];
	return parseInt(propertyData?.[countField]) || 0;
}

export function isPrimarySourcedRouteActive(dataSet, currentRoute) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	if (!menuConfig) {
		return false;
	}
	return menuConfig.entries.some(
		(entry) => getAppRoute(entry.dataSet, entry.dataSource) === currentRoute,
	);
}
